<template>
    <div class="advanced-search-list">
        <div class="layout-asl-title">
            <div class="layout-asl-title-box dsp-flex">
                <div class="layout-asl-result-title">搜索结果({{searchAdvancedResultList.length}}条记录)</div>
                <div class="layout-asl-sub-title" v-bind:class="{'direct-rtl': parseInt(settingConfigData.nianyueRishi) == 1}">
                    <span v-for="string in stringArr">{{string}}</span>
                </div>
            </div>
        </div>
        <div class="layout-asb-result-list" v-show="searchAdvancedResultList.length > 0">
            <virtual-list id="AdvancedSearchResultList" class="overflow-y-scroll scroll-touch"
                :data-key="'id'"
                :data-sources="searchAdvancedResultList"
                :data-component="itemComponent"
                :estimate-size="50"
                :item-class="itemClass" />
        </div>
        <!-- 多选对比 -->
        <search-select-button
            v-if="searchAdvancedResultList.length > 0"
            :fromPage="'advancedSearchResult'"
            :selectFunc="setSelectFunc">
        </search-select-button>
    </div>
</template>

<script>
import SearchResultAItem from '../../components/search/SearchResultAItem.vue'
import SearchResultSItem from '../../components/search/SearchResultSItem.vue'
import SearchSelectButton from '../../layouts/search/SearchSelectButton.vue'
import { SEARCH_DOM } from '../../modules/dom';
export default {
    name: 'AdvancedSearchList',
    components: { SearchSelectButton },
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        searchAdvancedResultList() {
            return this.$store.state.search.searchAdvancedResultList;
        },
        showSearchItemSelect() {
            return this.$store.state.search.showSearchItemSelect;
        }
    },
    data() {
        return {
            itemComponent: SearchResultAItem,
            itemClass: 'com-record-item-w90',
            stringArr: ['年', '月', '日', '时'],
        }
    },
    mounted() {
        this.$bus.on('resetItemComponent', this.resetItemComponent);
        setTimeout(() => {
            if(this.showSearchItemSelect) {
                this.setSelectFunc();
            }
        }, 20);
        setTimeout(() => {
            SEARCH_DOM.updateAdvancedSearchPageStyle();
        }, 100);
    },
    destroyed() {
        this.$bus.off('resetItemComponent', this.resetItemComponent);
    },
    methods: {
        setSelectFunc() {
            this.itemComponent = SearchResultSItem;
            this.itemClass = 'com-record-item-w88';
        },
        resetItemComponent() {
            this.itemComponent = SearchResultAItem;
            this.itemClass = 'com-record-item-w90';
        }

    }
}
</script>